import { Link } from '@tanstack/react-router'
import type { AuditEntryDto } from '@lunary/api-client'
import { FIELD_LABELS, ROLE_LABELS, formatValue } from './labels'
import styles from './audit-log.module.css'

export function EntryDetails({ entry }: { readonly entry: AuditEntryDto }) {
  const when = new Date(entry.created_at).toLocaleString('ru-RU', { timeZone: 'Europe/Moscow' })
  return (
    <div className={styles.details}>
      <div className={styles.meta}>
        <span>
          Кто: <b>{entry.actor_name ?? 'Без имени'}</b> · {ROLE_LABELS[entry.actor_role] ?? entry.actor_role}
        </span>
        <span>
          Когда: <b>{when}</b>
        </span>
        {entry.entity_id && (
          <span>
            Объект:{' '}
            {entry.entity_type === 'user' ? (
              <Link to="/users/$userId" params={{ userId: entry.entity_id }}>
                {entry.entity_label ?? entry.entity_id}
              </Link>
            ) : (
              <b className={styles.mono}>{entry.entity_id}</b>
            )}
          </span>
        )}
      </div>
      <div className={`${styles.meta} ${styles.mono}`}>
        <span>
          {entry.method} {entry.route}
        </span>
        {entry.request_id && <span>request {entry.request_id}</span>}
        {entry.ip && <span>IP {entry.ip}</span>}
        {entry.user_agent && <span className={styles.ua}>{entry.user_agent}</span>}
      </div>

      {entry.kind === 'error' ? (
        <div className={entry.status >= 500 ? styles.err5 : styles.err4}>
          <b>
            {entry.status} · <span className={styles.mono}>{entry.error_code}</span>
          </b>
          {entry.error_message && <div className="muted">{entry.error_message}</div>}
          <div className="muted">Изменений не было: запрос не выполнился. По request id запись находится в логах API.</div>
        </div>
      ) : entry.changes.length === 0 ? (
        <p className="muted">Без изменений полей.</p>
      ) : (
        <div className={styles.diff} role="table" aria-label="Было и стало">
          <div role="row" className={styles.diffHead}>
            <span role="columnheader">Поле</span>
            <span role="columnheader">Было</span>
            <span role="columnheader">Стало</span>
          </div>
          {entry.changes.map((c) => (
            <div role="row" key={c.field} className={styles.diffRow}>
              <span role="cell" className={styles.field}>
                {FIELD_LABELS[c.field] ?? c.field}
              </span>
              <span role="cell" className={styles.from}>
                {formatValue(c.from)}
              </span>
              <span role="cell" className={styles.to}>
                {formatValue(c.to)}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
